module.exports = __webpack_public_path__ + "static/media/mott_catalog_page3.dd844a77.png";